// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "오류 코드:",
    "error.search": "자세한 내용은 지식 기반 글에서 검색해 보세요.",
    dismiss: "해제",
    "installation.title": "",
    "cancelation.button": "취소",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "초기화 실패",
      description: "페이지를 렌더할 수 없습니다. 지원팀에 문의해 주세요.",
    },
    "EOS-UI-UE": {
      title: "오류가 발생했습니다.",
      description: "오류가 발생했습니다. 지원팀에 문의해 주세요.",
    },
    "EOS-IN-BC": {
      title: "설치 실패",
      description: "설치 진행률을 표시할 수 없습니다. 지원팀에 문의해 주세요.",
    },
    "EOS-IN-UE": {
      title: "설치 실패",
      description: "오류가 발생했습니다. 지원팀에 문의해 주세요.",
    },
    "EOS-IN-FF": {
      title: "설치 실패",
      description:
        "에픽 온라인 서비스에 연결할 수 없습니다. 지원팀에 문의해 주세요.",
    },
    "EOS-IN-FF-*": {
      title: "설치 실패",
      description:
        "에픽 온라인 서비스에 요청할 수 없습니다. 지원팀에 문의해 주세요.",
    },
    fallback: {
      title: "오류가 발생했습니다.",
      description: "오류가 발생했습니다.  지원팀에 문의해 주세요.",
    },
  },
};
